import { countryNameToCurrencyMap } from "@funded-here-interface/common/src/constant/country";

export const mapCountryToCurrencyCode = (country?: string): string => {
  if (!country) return "-";
  return countryNameToCurrencyMap.get(country) || "-";
};
